/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import Divider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import { Drawer, Box } from "@mui/material";
import moment from "moment";
import { MapData } from "client/models/MapData";
import { TaskData } from "context/TaskDataProvider";
import { ResultTaskList } from "client";
import { Const } from "const";
import { getNodeType } from "components/Map/NodeMapOverlay";

export const CustomDivider = styled(Divider)(({ theme }) => ({}));

export const TaskControlState = Object.freeze({
  NOT_DISPLAY: "NOT_DISPLAY",
  SELECT_TASK: "SelectTask",
  SELECT_POINT: "SelectPoint",
  SETTING: "Setting",
  CONFIRM: "Confirm",
});

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    margin: 32,
    width: window.innerWidth * 0.25,
    height: "93%",
    boxSizing: "border-box",
    borderWidth: 1,
    borderColor: "black",
  },
  "& .divider": {
    height: "1px",
    backgroundColor: theme.palette.divider,
  },
}));

interface DialogContainerProps {
  sidePanelWidth?: string;
}
export const DialogContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "sidePanelWidth",
})<DialogContainerProps>(({ theme, sidePanelWidth }) => ({
  flexGrow: 1,
  display: "grid",
  gridTemplateRows: "100%",
  gridTemplateColumns: `auto ${sidePanelWidth}`,
  gap: theme.spacing(1, 0),
  height: "100%",
}));

export const MapArea = styled(Box)({
  gridRow: "1",
  gridColumn: "1",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

export const DetailArea = styled(Box)({
  gridRow: "1",
  gridColumn: "2",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
});

export const PanelContentsArea = styled(Box)(({ theme }) => ({
  display: "flex",
  flexGrow: 1,
  backgroundColor: Const.sidePanelBodyColor,
  flexDirection: "column",
  height: "100%",
  overflow: "auto",
}));

export const PanelContentsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  gap: theme.spacing(0, 0),
  padding: "10px 20px 20px",
}));

export const getStartTimeOfTask = (date?: Date, today?: string): string => {
  if (!date) {
    return "--/--/---- --:--";
  }
  const dateMoment = moment(date);
  const now = new Date();
  const isToday =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  let textDisp = "";
  if (isToday) {
    textDisp = today + dateMoment.format(" HH:mm");
  } else {
    textDisp = dateMoment.format("DD/MM/YYYY HH:mm");
  }
  return textDisp;
};

export const getPointDescription = (
  id: number,
  mapInfo: MapData,
  defaultName: string
): string => {
  return (
    getNodeType(
      mapInfo.mapInfo.flatMap((m) => m.nodes).find((node) => node?.id === id)
        ?.description
    ).label ?? defaultName
  );
};

export const getTaskPlanNodeIds = (data: TaskData): Array<number> => {
  return [
    data.startNodeId!,
    ...(data.jobInfos?.map((job) => job.unloadingNodeId) ?? []),
    data.endNodeId!,
  ];
};

export const getTaskDataConvert = (taskResult: ResultTaskList): TaskData => {
  const newTaskData: TaskData = {
    ...taskResult,
  };
  return newTaskData;
};
